import { render, staticRenderFns } from "./PayrollTypesView.vue?vue&type=template&id=5a26ce20"
import script from "./PayrollTypesView.vue?vue&type=script&lang=js"
export * from "./PayrollTypesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports